// extracted by mini-css-extract-plugin
module.exports = {"center":"email_center__2fTpa","centerDiv":"email_centerDiv__1eggX"};